module.exports = __webpack_public_path__ + "img/34.6a9031dd.jpg";